export const SERVICE_UNAVAILABLE = 503;
export const NETWORK_ERROR = 'Network Error';
